module.exports = __webpack_public_path__ + "static/media/1.0fc81db2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/detail/1.gif
// module id = 685
// module chunks = 0